import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import SectionHeading from '../../components/SectionHeading';
import { BLOG_POSTS } from './posts';

export default function BlogList() {
  return (
    <>
      <Helmet>
        <title>Blog — Biryani2Go | Indian Breakfast & Biryani Guides</title>
        <meta
          name="description"
          content="Guides on Indian breakfast, dum biryani, and what to order at Biryani2Go — from morning classics to slow-cooked dinner dabbas."
        />
        <link rel="canonical" href="https://biryani2go.us/blog" />
      </Helmet>

      <section className="bg-maroon py-16 md:py-20">
        <div className="max-w-screen-xl mx-auto px-5 md:px-8">
          <SectionHeading
            eyebrow="From Our Kitchen"
            title="The Biryani2Go Blog"
            description="Stories, guides, and answers to the questions we get most — including what real Indian breakfast is supposed to taste like."
          />
        </div>
      </section>

      <section className="bg-surface py-16 md:py-24 min-h-[40vh]">
        <div className="max-w-screen-xl mx-auto px-5 md:px-8">
          {BLOG_POSTS.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {BLOG_POSTS.map((post, i) => (
                <motion.article
                  key={post.slug}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-60px' }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="card-tin overflow-hidden group"
                >
                  <Link to={`/blog/${post.slug}`} className="block">
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-6">
                      <p className="eyebrow mb-3">{post.category}</p>
                      <h2 className="font-display font-semibold text-xl text-maroon leading-snug mb-2">
                        {post.title}
                      </h2>
                      <p className="text-sm text-ink-2 leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                      <div className="flex items-center gap-4 text-xs text-ink-2 mb-4">
                        <span className="flex items-center gap-1.5">
                          <Calendar size={14} />
                          {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                        </span>
                        <span className="flex items-center gap-1.5">
                          <Clock size={14} />
                          {post.readTime}
                        </span>
                      </div>
                      <span className="inline-flex items-center gap-2 font-semibold text-ember group-hover:gap-3 transition-all">
                        Read More <ArrowRight size={16} />
                      </span>
                    </div>
                  </Link>
                </motion.article>
              ))}
            </div>
          ) : (
            <div className="card-tin p-16 text-center max-w-xl mx-auto">
              <p className="font-display text-2xl text-maroon mb-2">Stories coming soon</p>
              <p className="text-ink-2">We're writing up our first posts. Check back shortly.</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
